import React from 'react';
import { View, ScrollView, StyleSheet, TouchableOpacity, Text } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { H2, Body1, Body2, Caption } from '../../components/common/TextStyles';

const TermsScreen = () => {
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();

  const sections = [
    {
      title: "1. Acceptance of Terms",
      content: "By accessing and using the Youth Connect platform, you agree to be bound by these Terms and Conditions. Our platform is designed to provide educational content, financial tools, and community engagement for youth empowerment."
    },
    {
      title: "2. User Conduct",
      content: "Users are expected to maintain professional and respectful behavior within all areas of the app, including community spaces and mentor interactions. Any form of harassment, hate speech, or abuse will result in immediate account suspension."
    },
    {
      title: "3. Privacy and Data Support",
      content: "Your privacy is critical to us. We collect only necessary data to enhance your experience, such as your course progress, mission participation, and profile details. We do not sell your personal information to third parties."
    },
    {
      title: "4. Financial Tools",
      content: "The Pesa section provides financial management tools. While we strive for accuracy, these tools are for educational purposes. Users are responsible for their own financial decisions and the security of their transaction data."
    },
    {
      title: "5. Intellectual Property",
      content: "All content provided in the Soma and Mentor sections, including videos, documents, and interactive material, is the intellectual property of Youth Connect and its partners. Distribution or unauthorized use is prohibited."
    }
  ];

  return (
    <View style={styles.container}>
      <StatusBar style="dark" />
      <View style={[styles.header, { paddingTop: insets.top + 10 }]}>
        <TouchableOpacity style={styles.backBtn} onPress={() => navigation.goBack()}>
          <Ionicons name="arrow-back" size={24} color="#1E293B" />
        </TouchableOpacity>
        <H2 style={styles.headerTitle}>Terms & Conditions</H2>
        <View style={{ width: 40 }} />
      </View>

      <ScrollView contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
        <View style={styles.introBox}>
          <Body1 style={styles.lastUpdated}>Last Updated: March 16, 2026</Body1>
          <Body2 style={styles.introText}>
            Please read these terms carefully. They outline your rights and responsibilities when using the Youth Connect platform.
          </Body2>
        </View>

        {sections.map((section, index) => (
          <View key={index} style={styles.section}>
            <H2 style={styles.sectionTitle}>{section.title}</H2>
            <Body2 style={styles.sectionContent}>{section.content}</Body2>
          </View>
        ))}

        <View style={styles.agreementBox}>
          <Ionicons name="shield-checkmark" size={24} color="#10B981" />
          <Body2 style={styles.agreementText}>
            By continuing to use our app, you acknowledge that you have read and understood these terms.
          </Body2>
        </View>

        <View style={styles.footer}>
          <Caption style={styles.footerText}>© 2026 Youth Connect. All rights reserved.</Caption>
          <Caption style={styles.footerText}>Innovative Core v1.2</Caption>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    backgroundColor: '#FFFFFF',
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#F1F5F9',
  },
  backBtn: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F8FAFC',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerTitle: {
    fontSize: 18,
    color: '#1E293B',
  },
  scrollContent: {
    padding: 20,
    paddingBottom: 40,
  },
  introBox: {
    marginBottom: 25,
    paddingBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#F1F5F9',
  },
  lastUpdated: {
    fontSize: 12,
    color: '#94A3B8',
    marginBottom: 10,
    fontWeight: '700',
  },
  introText: {
    color: '#475569',
    lineHeight: 22,
  },
  section: {
    marginBottom: 25,
  },
  sectionTitle: {
    fontSize: 16,
    color: '#1E293B',
    marginBottom: 10,
  },
  sectionContent: {
    color: '#64748B',
    lineHeight: 22,
  },
  agreementBox: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F0FDF4',
    padding: 15,
    borderRadius: 12,
    gap: 12,
    marginTop: 10,
    marginBottom: 30,
  },
  agreementText: {
    flex: 1,
    color: '#166534',
    fontSize: 13,
  },
  footer: {
    alignItems: 'center',
    gap: 5,
  },
  footerText: {
    color: '#CBD5E1',
  }
});

export default TermsScreen;
